import algoliasearch from 'algoliasearch/lite'
import instantsearch from 'instantsearch.js'
import { configure, searchBox, hits, pagination, panel } from 'instantsearch.js/es/widgets'
import searchRouting from './search-routing'

export default function Search() {
  if ($('#search-results').length) {
    const searchClient = algoliasearch(process.env.ALGOLIA_SEARCH_APP_ID, process.env.ALGOLIA_SEARCH_API_KEY)
    const indexName = $('#search-index-name').val()

    const search = instantsearch({
      indexName: indexName,
      searchClient,
      routing: searchRouting(indexName),
    })

    const searchPanel = panel({
      templates: {
        footer(options) {
          let footer = '<div class="_algolia-summary-text c-summary-text">'
          if (options.results) {
            footer += `${options.results.nbHits} result${options.results.nbHits !== 1 ? 's' : ''} found`
            if (options.results.query) {
              footer += ` for <strong>${options.results.query}</strong>`
            }
          }
          return footer
        },
      },
    })(searchBox)

    search.addWidgets([
      configure({
        attributesToSnippet: ['objectTextContent'],
      }),

      searchPanel({
        container: '#search-box',
        placeholder: 'Search for helpful information, news, case studies and more...',
        showReset: true,
        searchAsYouType: true,
        cssClasses: {
          form: 'c-search__form c-search-page__form',
          input: 'c-search__input c-search-page__input',
          submit: 'c-button c-search__button c-search-page__submit',
          reset: 'c-button c-button--secondary c-search__reset',
        },
        templates: {
          submit: `<svg class="c-search__search-icon">
          <use xlink:href="/_resources/themes/udl/images/icons/icons.svg#search"></use>
        </svg><span class="c-search__search-text">Search</span>`,
          reset: `<svg class="c-search__reset-icon">
          <use xlink:href="/_resources/themes/udl/images/icons/icons.svg#close"></use>
        </svg><span class="c-search__reset-text">Clear</span>`,
        },
      }),

      hits({
        container: '#search-results',
        cssClasses: {
          list: 'c-results-list',
          item: 'c-results-list__item',
        },
        templates: {
          item: `
          <div class="c-result">
              <div class="c-result__content">
                  <h2 class="c-result__title">
                      <a class="c-result__link" href="{{ objectLink }}">
                          {{& objectTitle }}
                      </a>
                  </h2>
                  <p class="c-result__breadcrumbs">{{& objectBreadcrumbs }}</p>
                  <div class="c-result__desc">
                    {{#helpers.snippet}}{ "attribute": "objectTextContent" }{{/helpers.snippet}}
                  </div>
                  <p class="c-result__date">{{ objectDateDisplay }}</p>
              </div>
          </div>
        `,
          empty: `
          <p class="c-result__empty">No results found</p>
          `,
        },
      }),
      pagination({
        container: '#search-pagination',
        showFirst: false,
        showLast: false,
        scrollTo: '#search-box',
        cssClasses: {
          root: 'c-pagination',
          noRefinementRoot: ['c-pagination', 'c-pagination--empty'],
          list: 'c-pagination__list',
          previousPageItem: ['c-pagination__control', 'c-pagination__control--prev'],
          nextPageItem: ['c-pagination__control', 'c-pagination__control--next'],
          pageItem: 'c-pagination__item',
          selectedItem: ['c-pagination__item', 'c-pagination__item--selected'],
          disabledItem: ['c-pagination__item', 'c-pagination__item--disabled'],
          link: 'c-pagination__link',
        },
        padding: 2,
        templates: {
          previous: `
            <span class="c-pagination__text">Previous page</span>
            <svg class="c-button c-button--secondary c-button--icon-only c-pagination__icon">
              <use xlink:href="/_resources/themes/udl/images/icons/icons.svg#chevron-left"></use>
            </svg>
          `,
          next: `
            <span class="c-pagination__text">Next page</span>
            <svg class="c-button c-button--secondary c-button--icon-only c-pagination__icon">
              <use xlink:href="/_resources/themes/udl/images/icons/icons.svg#chevron-right"></use>
            </svg>
          `,
        },
      }),
    ])

    search.start()
  }
}
